import { Order } from '../../types';

export const defaultValuesProductForm = (currentProduct: Partial<Order> | undefined) => {
  const items = currentProduct?.ordersDetails?.map((itemDetail) => ({
    id: itemDetail.id,
    product: {
      label: itemDetail?.product?.product.name,
      value: itemDetail?.product?.product.id,
    },
    quantity: itemDetail.quantity,
    description: itemDetail.description,
    discount: itemDetail.discount,
    discountNumber: itemDetail.quantity_discount,
  }));
  return {
    table: currentProduct?.table || '',
    vendor: currentProduct?.vendor?.id || '',
    items: items || [],
  };
};
